export default __webpack_public_path__ + "static/media/history_1960_03.950932d0.png";